<template>
  <div class="promotion-header-actions">
<!--    <el-button-->
<!--        type="primary"-->
<!--        class="btn btn-xs promotion-action promotion-action&#45;&#45;import"-->
<!--        @click="$emit('import')"-->
<!--    >-->
<!--      <i class="el-icon-upload2" style="color:white"></i>-->
<!--      Import-->
<!--    </el-button>-->
    <el-button
        type="primary" :loading="loadingExport" :disabled="loadingExport"
        class="btn btn-xs promotion-action promotion-action--export"
        @click="$emit('export')"
    >
      <i class="el-icon-download" style="color:white"></i>
      Export
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'MangeGiftProgramHeaderActions',
  props: {
    loadingExport: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.promotion-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.promotion-action {
  border: none;
  color: #ffffff;
  height: 30px;
  min-width: 76px;
  padding: 7px 12px;
}

.promotion-action i {
  margin-right: 5px;
}

.promotion-action--import {
  background: #10bfb7;
}

.promotion-action--export {
  background: #0066ff;
}
</style>
